import Component from '~/components/component';

export default class LatestNews extends Component {
    constructor(...args) {
        super(...args);

        this._retrieveDOM();
    }

    _retrieveDOM() {
        this.dom.container = this.dom.component.querySelector('.js-news-container');
    }
    /*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// src/js/components/latest-news/latest-news.js